module.exports = __webpack_public_path__ + "img/icon-blue-phone.svg";